import React from "react";
import ReactDOM from "react-dom";
import "@fontsource/roboto";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App/App";

ReactDOM.render(
  <>
    <CssBaseline />
    <App />
  </>,
  document.getElementById("root")
);
